export default {
  rich: {
    common: {
      cancel: 'Cancelar',
      confirm: 'Aceptar',
      ok: 'Aceptar',
      selectText: 'Selecciona'
    },
    textArea: {
      placeholder: 'Especifica...'
    },
    segmentPicker: {
      next: 'Siguiente',
      prev: 'Volver'
    },
    timePicker: {
      now: 'Ahora',
      selectTime: 'Selecciona',
      today: 'Hoy',
      formatDate: 'DD/MM',
      hours: '',
      minutes: ''
    },
    resultPage: {
      emptyText: 'No hay datos disponibles',
      networkText: 'Error de red',
      networkSubtext: 'Haz clic para volver a cargar',
      lostText: 'No se encontró la página que buscas'
    },
    validator: {
      required: 'Esto es necesario',
      type: {
        string: 'Ingresa caracteres',
        number: 'Ingresa números',
        array: 'El tipo de datos debe ser una matriz',
        date: 'Ingresa una fecha válida',
        email: 'Ingresa un correo electrónico válido',
        tel: 'Ingresa un número de teléfono válido',
        url: 'Ingresa una URL válida'
      },
      min: {
        string: 'Debes ingresar al menos {{config}} caracteres',
        number: 'No puede ser menos que {{config}}',
        array: 'Selecciona un mínimo de {{config}} productos',
        date: 'Selecciona una fecha posterior a {{config | toLocaleDateString("yyyy-MM-dd")}}',
        email: 'Debes ingresar al menos {{config}} caracteres',
        tel: 'Debes ingresar al menos {{config}} caracteres',
        url: 'Debes ingresar al menos {{config}} caracteres'
      },
      max: {
        string: 'No se pueden superar los {{config}} caracteres',
        number: 'No puede ser más que {{config}}',
        array: 'Selecciona hasta {{config}} productos',
        date: 'Selecciona una fecha anterior a {{config | toLocaleDateString("yyyy-MM-dd")}}',
        email: 'No se pueden superar los {{config}} caracteres',
        tel: 'No se pueden superar los {{config}} caracteres',
        url: 'No se pueden superar los {{config}} caracteres'
      },
      len: {
        string: 'Ingresa {{config}} caracteres',
        number: 'La longitud debe ser igual a {{config}}',
        array: 'Selecciona {{config}} productos',
        date: 'Selecciona una fecha anterior a {{config | toLocaleDateString("yyyy-MM-dd")}}',
        email: 'Ingresa {{config}} caracteres',
        tel: 'Ingresa {{config}} caracteres',
        url: 'Ingresa {{config}} caracteres'
      },
      pattern: 'Error de formato',
      custom: 'Error de verificación',
      notWhitespace: 'Contenido en blanco no válido'
    }
  }
}
